import $ from 'jquery'
import { isSP } from './checkScreen'

const $header = $('#header')
const $logo = $header.find('.c-header-logo-link')
const $sectionWork = $('#top .l-section.-work')

const fadeLogo = () => {
  if ($sectionWork.length) {
    const SMALL_CLASS = '-is-active'
    const topSectionWork = $sectionWork.offset().top - 40

    $(window).on('scroll', () => {
      const windowTop = $(window).scrollTop()

      if (!isSP()) {
        $logo.toggleClass(SMALL_CLASS, $(window).scrollTop() > topSectionWork)
      }
    })
  }
}

const initHeader = () => {
  fadeLogo()
}

export default initHeader
